class InputTextHelper {
  static validateInputText = (val, prevVal) => {
    let newVal = val || '';
    const oldValue = prevVal || '';

    if ((!newVal || newVal.length <= 1) && newVal === ' ') {
      return '';
    }

    newVal = newVal.replace(/[^\w\s]/gi, '');

    if (oldValue.split('')[oldValue.length - 1] === ' ' && newVal.split('')[newVal.length - 1] === ' ') {
      return oldValue;
    }

    return newVal;
  };

  static cleanUpInputText = (val) => {
    let newVal = val;

    if (!newVal) newVal = '';
    if (!newVal) return newVal;

    if (newVal.split('')[newVal.length - 1] === ' ') {
      newVal = newVal.trimEnd();
    }

    return newVal;
  };
}

export default InputTextHelper;
